import { Unit } from './../../models/unit';
import { ServicesunitService } from './../../services/servicesunit.service';
import { CompaniesService } from 'src/app/services/companies.service';

import { User } from './../../models/user';
import { Company } from './../../models/backoffice/company';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { ModalInfo } from 'src/app/models/modal-info';
import { Project } from 'src/app/models/project';
import { ProjectsService } from './../../services/projects.service';
import { UsersService } from 'src/app/services/users.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ServiceUnit } from 'src/app/models/service-unit';


@Component({
  selector: 'app-servicesemt',
  templateUrl: './servicesemt.component.html',
  styleUrls: ['./servicesemt.component.scss']
})
export class ServicesemtComponent implements OnInit {

  @ViewChild('modalAddCompany') modalAddCompany: ModalDirective;

  constructor( private projectsService: ProjectsService, private servicesunitService: ServicesunitService, private usersService: UsersService, private companiesService: CompaniesService, private formBuilder: FormBuilder, private spinner: NgxSpinnerService) { }

  servicesUnit: ServiceUnit[] = [];
  units: Unit[] = [];

  projectsSubscription: Subscription;

  stateCompany: string = 'create'

  stateModal: boolean = false;
  stateModalAlert: boolean = false;
  modalInfo: ModalInfo = new ModalInfo();

  headElements = ['N°', 'Nombre', 'Unidad', 'Estado', 'Herramientas'];
  headTable = ['name', 'unitName', 'state', 'tools'];
  colspanLarge: number = 6;

  projectForm: FormGroup;

  states = [
    { value: true, label: 'Activo' },
    { value: false, label: 'Inactivo' },
  ];


  ngOnDestroy(){

    this.projectsSubscription.unsubscribe();
  }
  selectControl = new FormControl(['1']);

  ngOnInit(): void {

    this.spinner.show();

    this.resetForm();
    this.getServices();
    this.getUnits();
    // this.getCompanies();

    // this.getUsers();
  
  }

  resetForm(){

    // this.selectState = new FormControl(null);

    this.projectForm = this.formBuilder.group({
      name: [{ value: null, disabled: false }, Validators.required],
      // location: [{ value: null, disabled: false }, Validators.required],
      active: [{ value: null, disabled: false }, Validators.required],
      unit: [{ value: null, disabled: false }, Validators.required],
      users: [{ value: null, disabled: false}, Validators.required],

    });
  }
  

  reponseStateModal($event){
    this.stateModal = false;
  }


  submitCompany(){

    console.log('SUBMIT COMPANY');

    if(this.projectForm.invalid){

      this.stateModalAlert = true;  
      this.modalInfo.messageModal = 'Debe completar los campos correspondientes';
      this.modalInfo.type = 'error';
      return
    }

    if(this.stateCompany == 'create'){
      this.createService();
    }else{
      this.updateService(this.companySelected.uid);
    }
    this.modalAddCompany.hide();

  }

  getServices(){

    this.projectsSubscription = this.servicesunitService.getServices( ).subscribe({
      next: (resp) => { 
         this.servicesUnit = resp;
         console.log('Response: ' + resp); 
        },
      error: (err) => { console.log('Received an error: ' + err.message)},
      complete: () => { console.log('Completed'); this.stateModal = true;}
    });
  }

  getUnits(){

    this.projectsSubscription = this.projectsService.getUnits( ).subscribe({
      next: (resp) => { 
         this.units = resp;
         console.log('Response: ' + resp); 
        },
      error: (err) => { console.log('Received an error: ' + err.message)},
      complete: () => { 
        console.log('Completed');
        this.stateModal = true; 
        this.spinner.hide();
    }
    });
  }

  createService(){
  
    // this.projectForm.value.active = this.activeSelected;

    this.servicesunitService.createService( this.projectForm.value ).subscribe({
      next: (resp: any) =>{  
        console.log('Response: ' + resp);
        
        this.stateModalAlert = true;  
        this.modalInfo.messageModal = 'Servicio creado correctamente';
        this.modalInfo.type = 'success'        
    },
    error: (err) => { console.log('Received an error: ' + err)},
    complete: () => {  
        console.log('Completed');
        this.getServices();
    }
    });

  }

  updateService(id: string){
  
    this.servicesunitService.updateService( id, this.projectForm.value ).subscribe({
      next: (resp: any) =>{  
        console.log('Response: ' + resp);
        
        this.stateModalAlert = true;  
        this.modalInfo.messageModal = 'Compañia actualizada correctamente';
        this.modalInfo.type = 'success'        
    },
    error: (err) => { console.log('Received an error: ' + err)},
    complete: () => {  
        console.log('Completed');
        this.getServices();
    }
    });
  }

  deleteService(id: string){
  
    this.servicesunitService.deleteService( id ).subscribe({
      next: (resp: any) =>{  
        console.log('Response: ' + resp);
        
        this.stateModalAlert = true;  
        this.modalInfo.messageModal = 'Servicio eliminado correctamente';
        this.modalInfo.type = 'success'        
    },
    error: (err) => { 
      console.log('Received an error: ' + err)
      this.stateModalAlert = true;  
      this.modalInfo.messageModal = err.error.msg;
      this.modalInfo.type = 'error'  
    },
    complete: () => {  
        console.log('Completed');
        this.getServices();
    }
    });
  }

  showAddCompany(){

    console.log('SHOW MODAL');
    this.resetForm();
    this.stateCompany = 'create';
    this.modalAddCompany.show();
  }

  onResponseModalAlert($event){

    this.stateModalAlert = $event;
  }

  companySelected: Company;
  onreponsDeleteObjectTable($event){
    console.log('COMPANY: '+$event.uid);
    this.companySelected = $event;
    this.stateModalAlert = true;  
    this.modalInfo.messageModal = 'Esta seguro de eliminar '+$event.name;
    this.modalInfo.type = 'warning'    
  }

  onreponseUpdateObjectTable($event){
    console.log('COMPANY: '+$event.uid);
    this.companySelected = $event;
    this.stateCompany = 'update';
    this.modalAddCompany.show();

    // this.selectState = new FormControl($event.active);

    this.projectForm.get('name').setValue($event.name);
    this.projectForm.get('active').setValue($event.active);
    this.projectForm.get('unit').setValue($event.unitId);
    this.projectForm.get('users').setValue($event.users);


    // this.updateService(this.companySelected.uid);
  }

  onReponseDeleteObjectAlert($event){
    console.log('COMPANY: '+this.companySelected.uid);
    this.deleteService(this.companySelected.uid);
  }


  get name() {
    return this.projectForm.get('name');
  }

  // get location() {
  //   return this.projectForm.get('location');
  // }

  get active() {
    return this.projectForm.get('active');
  }

  get company() {
    return this.projectForm.get('company');
  }

  usersSubscription: Subscription;
  users: User[] = [];

  getUsersByUnit(id: string){

    this.usersSubscription = this.usersService.getUsersByUnit( id ).subscribe({
      next: (resp) => { 
         this.users = resp;
         console.log('Response: ' + resp); 
        },
      error: (err) => { console.log('Received an error: ' + err.message)},
      complete: () => { 
        console.log('Completed'); 
        this.stateModal = true;
      }
    });

  }

  // companies: Company[] = [];
  // companiesSubscription: Subscription;
  // getCompanies(){

  //   this.companiesSubscription = this.companiesService.getCompanies( ).subscribe({
  //     next: (resp) => { 
  //        this.companies = resp;
  //        console.log('Response: ' + resp); 
  //       },
  //     error: (err) => { console.log('Received an error: ' + err.message)},
  //     complete: () => { console.log('Completed'); this.stateModal = true;}
  //   });

  // }
  

  changedType(event){

    console.log('EVENT CHANGE: '+event);
    this.getUsersByUnit(event);
  }

}


